(function () {
  const START_DATE = new Date("2026-02-06T17:08:00+01:00");
  const END_DATE = new Date("2026-02-13T23:59:59+01:00");
  const THRESHOLD = 15000; // 150 EUR
  const TARGET_VARIANTS = [52018050236752, 52018050269520];
  const PROMO_PROP = "_auto_added_valentine";
  const OPT_OUT_KEY = "valentine_promo_opt_out";
  const OUT_OF_STOCK_KEY = "valentine_promo_out_of_stock";

  // Flag to prevent infinite loops during updates
  let isUpdating = false;

  const getCart = () => fetch("/cart.js").then((r) => r.json());

  const updateCart = (updates) =>
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates }),
    }).then((r) => r.json());

  const addItems = (items) =>
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items }),
    }).then((r) => {
      if (!r.ok) {
        return r.json().then((data) => {
          throw { status: r.status, data };
        });
      }
      return r.json();
    });

  async function reconcileCart() {
    if (isUpdating) return;

    try {
      const now = new Date();
      console.log("Valentine Promo: Checking cart...", { now, isUpdating });
      const cart = await getCart();

      const promoItemsInCart = cart.items.filter(
        (item) => item.properties && item.properties[PROMO_PROP],
      );

      // Calculate total excluding promo items to determine eligibility
      const promoCost = promoItemsInCart.reduce(
        (sum, item) => sum + item.final_line_price,
        0,
      );
      const eligibleTotal = cart.total_price - promoCost;

      const isDuringCampaign = now >= START_DATE && now <= END_DATE;
      const isAfterCampaign = now > END_DATE; // Logic to clean up after campaign

      console.log("Valentine Promo: Totals", {
        total: cart.total_price,
        promoCost,
        eligibleTotal,
        threshold: THRESHOLD,
      });

      let shouldHavePromo = false;

      if (isDuringCampaign) {
        if (eligibleTotal > THRESHOLD) {
          shouldHavePromo = true;
        }
      }

      const userOptedOut = sessionStorage.getItem(OPT_OUT_KEY) === "true";

      // Check for out of stock variants
      const outOfStockData = localStorage.getItem(OUT_OF_STOCK_KEY);
      let outOfStockVariants = outOfStockData ? JSON.parse(outOfStockData) : {};

      // Clean up expired out-of-stock entries (older than 24 hours)
    
      const ONE_DAY = 24 * 60 * 60 * 1000;
      let hasExpired = false;

      for (const vid in outOfStockVariants) {
        if (
          outOfStockVariants[vid].timestamp &&
          now - outOfStockVariants[vid].timestamp > ONE_DAY
        ) {
          delete outOfStockVariants[vid];
          hasExpired = true;
          console.log(
            `Valentine Promo: Cleared expired out-of-stock flag for variant ${vid}`,
          );
        }
      }

      if (hasExpired) {
        localStorage.setItem(
          OUT_OF_STOCK_KEY,
          JSON.stringify(outOfStockVariants),
        );
      }

      console.log("Valentine Promo: Decision", {
        shouldHavePromo,
        userOptedOut,
        outOfStockVariants,
      });

      // Determine actions
      if (shouldHavePromo) {
        if (userOptedOut) {
          console.log("Valentine Promo: User opted out. Skipping addition.");
        } else {
          // Check if we are missing any of the target variants with the property
          const itemsToAdd = [];

          for (const vid of TARGET_VARIANTS) {
            // Skip if variant is marked as out of stock
            if (outOfStockVariants[vid]) {
              console.log(
                `Valentine Promo: Skipping variant ${vid} - marked as out of stock`,
              );
              continue;
            }

            const existing = cart.items.find(
              (item) =>
                item.variant_id === vid &&
                item.properties &&
                item.properties[PROMO_PROP],
            );
            if (!existing) {
              itemsToAdd.push({
                id: vid,
                quantity: 1,
                properties: { [PROMO_PROP]: "true" },
              });
            }
          }

          if (itemsToAdd.length > 0) {
            console.log("Valentine Promo: Adding items", itemsToAdd);
            isUpdating = true;
            try {
              await addItems(itemsToAdd);
              window.location.reload();
            } catch (error) {
              console.error("Valentine Promo: Failed to add items", error);

              // Check if error is due to out of stock
              if (
                error.status === 422 ||
                (error.data && error.data.description)
              ) {
                const description = error.data?.description || "";

                // Mark items as out of stock if they failed to add
                if (
                  description.toLowerCase().includes("stock") ||
                  description.toLowerCase().includes("available") ||
                  description.toLowerCase().includes("inventory")
                ) {
                  const outOfStockData = localStorage.getItem(OUT_OF_STOCK_KEY);
                  const outOfStock = outOfStockData
                    ? JSON.parse(outOfStockData)
                    : {};

                  // Mark all attempted items as out of stock with timestamp
                  itemsToAdd.forEach((item) => {
                    outOfStock[item.id] = {
                      timestamp: Date.now(),
                      reason: description,
                    };
                    console.log(
                      `Valentine Promo: Marking variant ${item.id} as out of stock`,
                    );
                  });

                  localStorage.setItem(
                    OUT_OF_STOCK_KEY,
                    JSON.stringify(outOfStock),
                  );
                }
              }

              isUpdating = false;
            }
          }
        }
      } else {
        // Should NOT have promo (either below threshold, outside dates, or ended)
        // Remove any promo items (those with the property)
        const updates = {};
        let hasRemovals = false;

        for (const item of cart.items) {
          if (item.properties && item.properties[PROMO_PROP]) {
            updates[item.key] = 0;
            hasRemovals = true;
          }
        }

        if (hasRemovals) {
          console.log("Valentine Promo: Removing items", updates);
          isUpdating = true;
          await updateCart(updates);
          window.location.reload();
        }
      }
    } catch (e) {
      console.error("Valentine Promo Error", e);
    } finally {
      isUpdating = false;
    }
  }

  async function removeValentineGift() {
    console.log("Valentine Promo: User explicitly removing gift.");
    sessionStorage.setItem(OPT_OUT_KEY, "true");

    try {
      isUpdating = true;
      const cart = await getCart();
      const updates = {};
      let hasRemovals = false;

      for (const item of cart.items) {
        if (item.properties && item.properties[PROMO_PROP]) {
          updates[item.key] = 0;
          hasRemovals = true;
        }
      }

      if (hasRemovals) {
        await updateCart(updates);
      }
      window.location.reload();
    } catch (e) {
      console.error("Failed to remove valentine gift", e);
      isUpdating = false;
    }
  }

  // Hook into fetch to detect cart changes
  const originalFetch = window.fetch;
  window.fetch = function () {
    return originalFetch.apply(this, arguments).then((response) => {
      if (
        response.url.includes("/cart/add") ||
        response.url.includes("/cart/update") ||
        response.url.includes("/cart/change")
      ) {
        setTimeout(reconcileCart, 500);
      }
      return response;
    });
  };

  // Event listener for removal button
  document.addEventListener("click", function (e) {
    if (e.target && e.target.id === "remove-valentine-gift") {
      e.preventDefault();
      removeValentineGift();
    }
  });

  // Initial check on load
  reconcileCart();
})();
